import React from "react";
import { List } from "../modules/InvoiceReconciliation";

export function InvoiceReconciliationPage() {
  return <List />;
}
